'use strict';

angular.module('theme').component('portionButton', {
	templateUrl: 'component/portion-button.html',
	bindings: {
		productId: '<',
		specialArticle: '<',
		servings: '<',
		prices: '<',
		onSelect: '&',
	},
	controller: function ($scope, $attrs, $element, ArticleService) {
		var self = this;

		this.btnBlock = 'block' in $attrs;
		this.btnLarge = 'large' in $attrs;
		this.showLabel = 'showLabel' in $attrs;
		this.hideServings = 'hideServing' in $attrs;

		if (this.btnBlock) {
			$element.addClass('display-block');
		}

		this.isOpen = false;

		var getData = function () {
			ArticleService.getProduct(self.productId).then(function (product){
				self.available = product['prices'][0].available;
				self.hideServings = false;

				if (!self.productId || (!self.servings && self.servings < 0)) {
					return;
				}

				if(self.available < 8){
					self.hideServings = true;
					return;
				}

				if (self.specialArticle) {
					self.prices = self.specialArticle.prices;
					self.selected = _.find(self.prices, {number: self.servings});
				} else {
					ArticleService.getProduct(self.productId).then(function (product) {
						self.special = product.type === 'Special';
						self.prices = product.prices;
						self.selected = _.find(self.prices, {number: self.servings});
					});
				}
			});
		};

		$scope.$watch('$ctrl.productId', getData);
		$scope.$watch('$ctrl.servings', getData);

		this.select = function (servings) {
			self.selected = _.find(self.prices, {number: servings});
			self.onSelect({$servings: servings});
		};
	}
});
